export default "__VITE_ASSET__zPpFW71e__"